import React from "react";

import { CopyTextIcon } from "src/base-components/CopyTextIcon";

type Props = {
  label: string;
  value: string;
  dataLoc?: string;
};

export const CredentialField: React.FC<Props> = ({ label, value, dataLoc }) => (
  <div className="flex flex-col gap-1" data-loc={dataLoc}>
    <span className="font-inter-normal-12px text-gray-500">{label}</span>
    <div className="flex w-full items-center justify-between gap-x-2 break-all rounded-lg border border-gray-300 py-2 pr-3 pl-2 font-code-12 text-gray-800">
      {value}
      <CopyTextIcon feedback="inline" tooltip="Copy" value={value} />
    </div>
  </div>
);
